import { createFileRoute } from '@tanstack/react-router';
import { Activity } from 'lucide-react';
import { ComingSoon } from '@/components/layout/ComingSoon';

export const Route = createFileRoute('/_app/lancamentos/atividades')({
  component: AtividadesPage,
});

function AtividadesPage() {
  return (
    <ComingSoon
      eyebrow="Lançamento · Mensal"
      title="Atividades"
      description="Atividades realizadas com os recursos do convênio."
      icon={Activity}
      bullets={[
        'Cadastro do tipo de atividade e público atendido',
        'Métricas de execução (quantitativos)',
        'Anexo de relatório e fotos',
      ]}
      etaLabel="próxima fase"
    />
  );
}
